import { useParams } from 'react-router-dom';
import React, { useState } from "react";
import { Container, Row } from "reactstrap";
import LetterLeftAside from "./LetterLeftAside";
import LetterRightAside from "./LetterRightAside";
import { useEmailList } from "../../../Features/letterBox/hooks/useList";

export default function LetterBoxContainer() {
  const { emailId } = useParams();
  const [navId, setNavId] = useState("1");

  const { data, isLoading, isError } = useEmailList();

  // valori di fallback se data è undefined
  const listEmail     = data?.list      ?? [];
  const n_pages       = data?.n_pages   ?? 1;
  const actives       = data?.actives   ?? 0;
  const deleted       = data?.deleted   ?? 0;
  const favourite     = data?.favourite ?? 0;

  if (isError && !emailId) {
    return <p>Errore nel caricamento</p>;
  }

  return (
    <Container fluid>
      <div className="email-wrap email-main-wrapper">
        <Row className="pt-3">
          <LetterLeftAside
            navId={navId}
            setNavId={setNavId}
            actives={actives}
            deleted={deleted}
            favourite={favourite}
          />
          <LetterRightAside
            navId={navId}
            listEmail={listEmail}
            n_pages={n_pages}
            isLoading={isLoading}
          />
        </Row>
      </div>
    </Container>
  );
}
